import Vue from 'vue'
import Router from 'vue-router'
import Home from './pages/Home.vue'
import Products from './pages/Products.vue'
import Recipes from './pages/Recipes.vue'
import Favorites from './pages/Favorites.vue'
import Mixologists from './pages/Mixologists.vue'

Vue.use(Router)

export default new Router({
  mode: window.cordova ? '' : 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      meta: {index: 0},
      component: Home
    },
    {
      path: '/products',
      name: 'products',
      meta: {index: 1},
      component: Products
    },
    {
      path: '/recipes',
      name: 'recipes',
      meta: {index: 2},
      component: Recipes
    },
    {
      path: '/favorites',
      name: 'favorites',
      meta: {index: 3},
      component: Favorites
    },
    {
      path: '/mixologists',
      name: 'mixologists',
      meta: {index: 4},
      component: Mixologists
    },
  ]
})
